"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("../../moment/moment-and-timezone-init");

var _legacyI18nInit = require("../../internal/legacyI18nInit");

var _es = _interopRequireDefault(require("i2l?mode=very-lazy&query=sporks!moment/locale/es"));

// To do: We currently have to point to an arbitrary locale.
// Need extra lazy loader
var _default = function _default(Provider) {
  return Provider.register(_es.default, {
    localeMapper: _legacyI18nInit.momentLocaleMapper
  }).then(function () {
    var validMomentLocale = _legacyI18nInit.momentMappings[I18n.locale] || _legacyI18nInit.momentMappings[I18n.locale.substring(0, 2)] || _legacyI18nInit.defaultLanguage;

    return I18n.moment.locale(validMomentLocale);
  });
};

exports.default = _default;
module.exports = exports.default;